const calcLinePosition = (indexValue, width, index, length, xScale) => {
    if (index === 0) return xScale(indexValue);
    if (index === length - 1) return xScale(indexValue) + width;
    return xScale(indexValue) + width / 2;
}
export default calcLinePosition;